import { createBrowserHistory } from 'history'

export const history = createBrowserHistory()

export const navigate = history.push.bind(history)
